import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// Firebase configuration for ShieldPayments
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyDummyKeyNotNeededForFCM",
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "shieldpaymentsapp.firebaseapp.com",
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "shieldpaymentsapp",
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "shieldpaymentsapp.appspot.com",
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "103907359254791046686",
    appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:103907359254791046686:web:shieldpayments"
};

// Initialize Firebase
let app = null;
let messaging = null;

const initFirebase = () => {
    if (app) return; // Already initialized
    
    try {
        if (typeof window === 'undefined') return;
        
        app = initializeApp(firebaseConfig);
        
        // Check if browser supports notifications
        if ('Notification' in window && 'serviceWorker' in navigator) {
            messaging = getMessaging(app);
            console.log('Firebase Messaging initialized');
        }
    } catch (error) {
        console.log('Firebase initialization error:', error.message);
    }
};

// Initialize on module load (client-side only)
if (typeof window !== 'undefined') {
    initFirebase();
}

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

export const requestNotificationPermission = async () => {
    // Ensure Firebase is initialized
    initFirebase();
    
    if (!messaging) {
        console.log('Messaging not supported in this browser');
        return null;
    }

    if (!VAPID_KEY) {
        console.error('VAPID_KEY not configured');
        return null;
    }

    try {
        console.log('Requesting notification permission...');
        const permission = await Notification.requestPermission();
        console.log('Notification permission:', permission);
        
        if (permission === 'granted') {
            console.log('Getting FCM token with VAPID key...');
            const token = await getToken(messaging, { vapidKey: VAPID_KEY });
            console.log('FCM Token obtained:', token ? token.substring(0, 30) + '...' : 'null');
            return token;
        } else {
            console.log('Notification permission denied');
        }
        return null;
    } catch (error) {
        console.error('Error getting FCM token:', error.message);
        return null;
    }
};

export const onMessageListener = () => {
    initFirebase();
    
    if (!messaging) return Promise.reject('Messaging not supported');
    
    return new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            console.log('Message received:', payload);
            resolve(payload);
        });
    });
};

export { app, messaging };
